import CompanyWorkCalendarContent from "../../features/companyWork/widgets/CompanyWorkCalendarContent";

function CompanyWorkCalendarScreen() {
  return <CompanyWorkCalendarContent />;
}

export default CompanyWorkCalendarScreen;
